import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import {ArrowBack} from "@mui/icons-material";

import {findFlagUrlByIso2Code} from 'country-flags-svg';
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import {SGP} from "./sgp-results-react";
import {countryArray} from "../util/sgp-util";
import {styled} from "@mui/material/styles";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import {grey} from "@mui/material/colors";


export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#333333',
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '.85em',
    },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: grey[100],
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const PilotRegistrationList = ({eventId, eventStatus}) => {

    const [mode, setMode] = React.useState('list')
    const [data, setData] = React.useState()

    useEffect(() => {
        // fetch data
        const dataFetch = async () => {
            const ret = await (
                await fetch(SGP.dataUrl+`/public/get/event/registrations?eventId=${eventId}`)
            ).json();

            setData(ret)
        };

        dataFetch();
    }, []);



    const onClosePilotInfo = () => {
        setMode('list')
    }


    return (
        <>
            {data && mode === 'list' &&
                <TableContainer component={'div'} sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>#</StyledTableCell>
                                <StyledTableCell>Pilot</StyledTableCell>
                                <StyledTableCell sx={{textAlign:'center'}}>Nationality</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.registrations.map((reg,idx) => {
                                    const pilot = data.pilots.find(p => p.id === reg.p)
                                    if (eventStatus<=20 && reg.u!==64 && reg.u!==32) return undefined
                                    return pilot && (
                                        <StyledTableRow
                                            key={reg.i}
                                            sx={{
                                                '&:last-child td, &:last-child th': {border: 0},
                                                "&:hover": {backgroundColor: "#D3EDF4 !important"},
                                            }}
                                            onClick={(e) => {
                                            }}
                                        >
                                            <StyledTableCell component="th" scope="row">
                                                {idx + 1}
                                            </StyledTableCell>
                                            <StyledTableCell>{pilot.firstname} {pilot.lastname}</StyledTableCell>
                                            <StyledTableCell sx={{textAlign:'center'}}><Tooltip title={countryArray.find( c => c.key===pilot.nationality).label} arrow><img src={findFlagUrlByIso2Code(pilot.nationality)} style={{height:'1.2em'}}/></Tooltip></StyledTableCell>
                                            <StyledTableCell>{reg.u !==64 && reg.u !==32 ? 'Preliminary' : ''}</StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            {data && mode === 'pilotInfo' &&
                <>
                    <Box sx={{
                        display:'flex',
                        alignItems:'center',
                        //justifyContent:'space-between',
                        my:'1em',
                        columnGap:'2em',
                    }}>
                        <IconButton onClick={()=>{onClosePilotInfo()}}><ArrowBack/></IconButton>
                        <Typography variant={'h2'} flexGrow={1} textAlign={'left'}>Pilot profile</Typography>
                    </Box>
                </>
            }
        </>
    )
}

export default PilotRegistrationList